export const hr = {
    languages: {
        cs: 'Češki',
        de: 'Njemački',
        en: 'Engleski',
        es: 'Španjolski',
        fr: 'Francuski',
        hr: 'Hrvatski',
        hu: 'Mađarski',
        it: 'Talijanski',
        nl: 'Nizozemski',
        pl: 'Poljski',
        ru: 'Ruski',
        sk: 'Slovački',
        tr: 'Turski',
        uk: 'Ukrajinski',
        undefined: 'Bez titlova',
    },
    player: {
        content: {
            notFound: { title: 'Greška pri učitavanju medijskog elementa 😞' },
        },
        controls: {
            backwards: { title: '10s unatrag' },
            buffering: { title: 'Učitavanje...' },
            captions: { title: 'Titlovi' },
            forwards: { title: '10s unaprijed' },
            fullscreen: { title: 'Cijeli zaslon' },
            pause: { title: 'Pauza' },
            play: { title: 'Reproduciraj' },
            playlist: { title: 'Popis pjesama' },
            volume: { title: 'Glasnoća' },
        },
    },
};
